<template>
  <FKBreadCrumb :page="$t('page.create')" :title="$t('page.create_patient')">
    <FKBreadCrumbItem :page="$t('page.patients')" to="/patients" />
  </FKBreadCrumb>
  <PatientForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import PatientForm from "@/components/FK/Patient/PatientForm.vue";

export default defineComponent({
  name: "CreatePatientPage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    PatientForm,
  },
});
</script>